import { Outlet, useNavigation } from 'react-router';
import { useEffect, useState } from 'react'
import type { Dispatch, FC, ReactNode } from 'react'

import { AuthLayout } from '~/components/layouts'
import { LoadingOverlay } from '~/components/loading'
import { Logo } from '~/components/logo'

export type ContextType = {
  setIsLoading: Dispatch<boolean>
}

export const Text: FC<{ children: ReactNode }> = ({ children }) =>
  <p className='my-5 text-center'>{children}</p>

export const ErrorText: FC<{ children: ReactNode }> = ({ children }) =>
  <p className='my-5 text-center text-error'>{children}</p>


export default function Register() {
  const [isLoading, setIsLoading] = useState<boolean>(false)
  const navigation = useNavigation()

  useEffect(() => {
    setIsLoading(Boolean(navigation.state !== "idle"))
  }, [navigation])

  const context: ContextType = {
    setIsLoading: setIsLoading,
  }

  return (
    <AuthLayout>
      <LoadingOverlay isLoading={isLoading} />
      <Logo />
      <div className='flex justify-center'>
        <Outlet context={context} />
      </div>
    </AuthLayout>
  )
}
